/**
 * Shared Swiper bundle - the only copy of Swiper the theme ships.
 *
 * It contains exactly the modules the sliders use: HeroSlider (and everything built on it - quotes,
 * testimonials, the cards carousel, the gallery and the content slider container) needs Navigation,
 * Pagination and Autoplay; the timelines need Keyboard and A11y. It used to bundle all 23 modules and
 * every effect stylesheet (234 KB), while HeroSlider.js carried a second copy of Swiper on top, so a
 * page with a hero and a timeline downloaded Swiper twice. When a slider starts using another module,
 * add the module and its stylesheet here.
 *
 * Nothing is registered globally with Swiper.use(): each slider passes its own `modules`, so adding a
 * module for one slider can never switch it on for all the others (A11y, for instance, rewrites the
 * ARIA markup of every slider it is active on).
 *
 * Exposes window.Swiper and window.SwiperModules (plus the old HdSwiper aliases) and then dispatches
 * "swiper:ready" on document. Consumers wait through lib/whenSwiper.js, because all bundles load
 * async and a slider may be initialised before this file has run.
 */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, A11y, Keyboard } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/a11y'

const modules = { Navigation, Pagination, Autoplay, A11y, Keyboard }

window.Swiper = Swiper
window.SwiperModules = modules

// Backwards compatibility with the names HeroSlider.js used to expose.
window.HdSwiper = Swiper
window.HdSwiperModules = modules

document.dispatchEvent(new CustomEvent('swiper:ready'))
